import { rawCall, call, METHODS, signalToAxiosOptions } from '../http-client'
import { filtersToQueryString } from '../Filter/filter.service'
import { base64ToFile } from '../File/File.service'

const ROUTE_PREFIX = 'order'

export const getOrder = async (id) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, id)
    } catch (e) {
        console.error(`getOrder error: ${e}`)
        throw e
    }
}

export const getCurrentOrders = async () => {
    return call(METHODS.GET, ROUTE_PREFIX, 'current')
}

export const getOrderDeliveryInfo = async (id) => {
    return await call(METHODS.GET, ROUTE_PREFIX, `${id}/delivery`)
}

export const getOrders = async (state, body) => {
    return await call(METHODS.GET, ROUTE_PREFIX, state, {params: body})
}

export const getOrderEvents = async (orderId) => {
    return call(METHODS.GET, ROUTE_PREFIX, `${orderId}/orderEvents`)
}

export const downloadMetrics = async (body) => {
    return await rawCall(METHODS.POST, ROUTE_PREFIX, `download`, body, {
        responseType: 'blob',
        timeout: 90000,
    })
}

export const downloadVatOrders = async (body) => {
    return await rawCall(METHODS.POST, ROUTE_PREFIX, `download/vat`, body, {
        responseType: 'blob',
        timeout: 150000,
    })
}

export const getOrderDenyReasonTypes = async () => {
    return await call(METHODS.GET, ROUTE_PREFIX, 'denyReasonTypes')
}

export const denyOrder = async (order, denyReason) => {
    return await call(METHODS.POST, ROUTE_PREFIX, `${order.id}/deny`, {order, denyReason})
}

export const convertOrderItemsToFulfillmentIssues = (orderItemsWithFulfillmentIssues, orderItemsReplacements) => {
    return orderItemsWithFulfillmentIssues.map(orderItemsWithFulfillmentIssue => {
        const substitution = orderItemsReplacements.find(oi => oi.fulfillmentIssueParentId === orderItemsWithFulfillmentIssue.id)

        if (substitution) {
            return {
                issueType: 'SUBSTITUTION',
                id: orderItemsWithFulfillmentIssue.id,
                itemId: orderItemsWithFulfillmentIssue.itemId,
                substitution: {
                    id: substitution.substitutionId,
                    itemId: substitution.itemId,
                    itemQuantity: substitution.quantity,
                    ...(substitution.scanned ? {scanned: true} : {}),
                },
            }
        } else if (orderItemsWithFulfillmentIssue.quantity) {
            return {
                issueType: 'PARTIAL_AVAILABILITY',
                id: orderItemsWithFulfillmentIssue.id,
                itemId: orderItemsWithFulfillmentIssue.itemId,
                itemAvailable: +orderItemsWithFulfillmentIssue.quantity,
            }
        } else if (!orderItemsWithFulfillmentIssue.fulfillmentAction || orderItemsWithFulfillmentIssue.fulfillmentAction === 'CANCEL_ORDER') {
            return {
                issueType: 'OUT_OF_ITEM',
                id: orderItemsWithFulfillmentIssue.id,
                itemId: orderItemsWithFulfillmentIssue.itemId,
                issueAction: 'CANCEL_ORDER',
            }
        } else {
            return {
                issueType: 'OUT_OF_ITEM',
                id: orderItemsWithFulfillmentIssue.id,
                itemId: orderItemsWithFulfillmentIssue.itemId,
                issueAction: 'REMOVE_ITEM',
            }
        }
    })
}

export const setFulfillmentIssues = async (orderId, fulfillmentIssues) => {
    return await call(METHODS.PUT, ROUTE_PREFIX, `${orderId}/fulfillmentIssues`, {fulfillmentIssues}, {
        'axios-retry': {
            retries: 0,
        },
    })
}


export const setPickingMethod = async (order, pickingMethod, orderItemIds) => {
    return await call(METHODS.PUT, ROUTE_PREFIX, `${order.id}/pickingMethod`, {
        pickingMethod,
        orderItemIds,
    })
}

export const getFulfillmentAlternatives = async ({
                                                     order,
                                                     orderItem,
                                                     needle,
                                                     quantity,
                                                     page,
                                                     size,
                                                 }, signal = null) => {
    const queryParams = filtersToQueryString({needle, quantity, page, size})
    const baseOptions = {
        headers: {
            'x-ulty-can-handle-errors': true,
        }
    }
    return await call(
      METHODS.GET,
      ROUTE_PREFIX,
      `${order.id}/fulfillmentAlternative/${orderItem.itemId}${queryParams}`,
      signalToAxiosOptions(signal, baseOptions) || baseOptions,
    )
}

export const acceptOrder = async (order, delayPickupTimeMinutes) => {
    return await call(METHODS.POST, ROUTE_PREFIX, `${order.id}/accept`, {order, delayPickupTimeMinutes})
}

export const delayPickupTime = async (orderId, delayPickupTimeMinutes) => {
    return await call(METHODS.POST, ROUTE_PREFIX, `${orderId}/delay-pickup-time`, { delayPickupTimeMinutes })
}

export const cancelOrder = async (order) => {
    return await call(METHODS.DELETE, ROUTE_PREFIX, `${order.id}`)
}

export const updateOrderCouriers = async (order, couriers) => {
    return await call(METHODS.POST, ROUTE_PREFIX, `${order.id}/couriers`, {couriers})
}

export const addEventToOrder = async (orderId, eventType) => {
    return await call(METHODS.POST, ROUTE_PREFIX, `${orderId}/events`, {eventType})
}

export const postPickingProof = async (orderId, pickingProof) => {
    try {
        const file = await base64ToFile(pickingProof, 'pickingProof.jpeg', 'image/jpeg')
        const bodyFormData = new FormData()
        bodyFormData.append('pickingProof', file)
        return await call(METHODS.POST, ROUTE_PREFIX, `${orderId}/picking-proofs`, bodyFormData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
    } catch (e) {
        console.error(`postPickingProof error: ${e.message}`)
        throw e
    }
}

export const getPickingProofUrl = async (orderId, pickingProofId) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${orderId}/picking-proofs/${pickingProofId}`)
    } catch (e) {
        console.error(`getPickingProofUrl error: ${e.message}`)
        throw e
    }
}

export const getOrderPickingProofsUrls = async (orderId) => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, `${orderId}/picking-proofs`)
    } catch (e) {
        console.error(`getOrderPickingProofsUrls error: ${e.message}`)
        throw e
    }
}
